import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Divider, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    Dialog, DialogTitle, DialogContent, DialogActions
 } from '@mui/material';
import { collection, query, where, getDocs, doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useLocation, useNavigate } from "react-router-dom";

export default function Payment() {
  const location = useLocation();
  const navigate = useNavigate();

  const { cartId, tableId, orderId, companyCode, unitCode } = location.state || {};

  const [orderedItems, setOrderedItems] = useState([]);
  const [loading, setLoading] = useState(true);


const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);

const handleOpenPaymentDialog = () => setPaymentDialogOpen(true);
const handleClosePaymentDialog = () => setPaymentDialogOpen(false);
const [gstPlansMap, setGstPlansMap] = useState({});
const [menuMap, setMenuMap] = useState(new Map());
  const [totals, setTotals] = useState({
    subtotal: 0,
    cgst: 0,
    sgst: 0,
    grandTotal: 0
  });

  const [companyInfo, setCompanyInfo] = useState({
    name: "",
    address: "",
    phone: ""
  });
  const [orderNo, setOrderNo] = useState("");

  useEffect(() => {
    const fetchCompanyInfo = async () => {
      if (!companyCode) return;
      try {
        const companyDoc = await getDoc(doc(db, "companies", companyCode));
        if (companyDoc.exists()) {
          setCompanyInfo(companyDoc.data());
        } else {
          console.warn("Company not found");
        }
      } catch (err) {
        console.error("Error fetching company info:", err);
      }
    };

    fetchCompanyInfo();
  }, [companyCode]);

  useEffect(() => {
    const fetchGstPlans = async () => {
      if (!companyCode) return;
  
      const q = query(
        collection(db, "gstPlans"),
        where("companyCode", "==", companyCode)
      );
  
      const snapshot = await getDocs(q);
  
      const map = {};
      snapshot.forEach(doc => {
        const data = doc.data();
        map[data.gstName] = data; // key by gstName
      });
  
      setGstPlansMap(map);
    };
  
    fetchGstPlans();
  }, [companyCode]);

  useEffect(() => {
  const fetchMenu = async () => {
    if (!companyCode || !unitCode) return;

    try {
      const menuQuery = query(
        collection(db, "companymenu"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode)
      );

      const snapshot = await getDocs(menuQuery);

      const map = new Map();

      snapshot.forEach(doc => {
        const data = doc.data();

        // assuming itemCode is unique
        map.set(data.itemCode, data);
      });

      setMenuMap(map);
    } catch (err) {
      console.error("Error fetching menu:", err);
    }
  };

  fetchMenu();
}, [companyCode, unitCode]);

const [gstin, setGstin] = useState("");
useEffect(() => {
  const fetchUnitInfo = async () => {
    if (!unitCode) return;

    try {
      const unitDoc = await getDoc(doc(db, "units", unitCode));
      if (unitDoc.exists()) {
        const data = unitDoc.data();
        console.log("Unit Data:", data);

        setGstin(data.gstin || ""); // ✅ store GSTIN
      } else {
        console.warn("Unit not found");
      }
    } catch (err) {
      console.error("Error fetching unit info:", err);
    }
  };

  fetchUnitInfo();
}, [unitCode]);
  useEffect(() => {
    const fetchItems = async () => {
      if (!cartId && !orderId) return;

      const servedStatuses = ["Ordered", "Confirmed", "Preparing", "Ready", "Served"];
      let combinedItems = [];

      try {
        // Fetch from carts table
        if (cartId) {
          const cartQuery = query(collection(db, "carts"), where("cartId", "==", cartId));
          const cartSnapshot = await getDocs(cartQuery);
          if (!cartSnapshot.empty) {
            const cartData = cartSnapshot.docs[0].data();
            const cartItems = cartData.items || [];
            combinedItems = [...combinedItems, ...cartItems.filter(item => servedStatuses.includes(item.status))];
          }
        }

        // Fetch from orders table
        if (orderId) {
          const orderQuery = query(collection(db, "orders"), where("orderId", "==", orderId));
          const orderSnapshot = await getDocs(orderQuery);
          if (!orderSnapshot.empty) {
            const orderData = orderSnapshot.docs[0].data();
            const orderItems = orderData.items || [];
            combinedItems = [...combinedItems, ...orderItems.filter(item => servedStatuses.includes(item.status))];

             if (orderData.orderNo) {
      setOrderNo(orderData.orderNo);
    }
          }
        }

        // Remove duplicates
        const uniqueItemsMap = {};
        combinedItems.forEach(item => {
          uniqueItemsMap[item.id] = item;
        });
        const uniqueItems = Object.values(uniqueItemsMap);

        // Calculate totals
        let subtotal = 0, cgst = 0, sgst = 0;
        /*uniqueItems.forEach(item => {
          const price = Number(item.totalPrice || 0);
          subtotal += price;
          cgst += price * 0.025;
          sgst += price * 0.025;
        });*/
       /* uniqueItems.forEach(item => {
  const price = Number(item.totalPrice || 0);

  const menuItem = menuMap.get(item.itemCode);
  const gstPercent = menuItem?.gstPercentage || 0;
  const gstRate = gstPercent / 100;

  const itemCGST = price * (gstRate / 2);
  const itemSGST = price * (gstRate / 2);

  subtotal += price;
  cgst += itemCGST;
  sgst += itemSGST;
});

        setTotals({
          subtotal,
          cgst,
          sgst,
          grandTotal: subtotal + cgst + sgst
        });*/

        setOrderedItems(uniqueItems);
      } catch (err) {
        console.error("Error fetching items:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchItems();
  }, [cartId, orderId]);

  useEffect(() => {
  if (!orderedItems.length || menuMap.size === 0) return;

  let subtotal = 0, cgst = 0, sgst = 0;

  /*orderedItems.forEach(item => {
    const price = Number(item.totalPrice || 0);

    const menuItem = menuMap.get(item.itemCode);
    const gstPercent = Number(menuItem?.gstPercentage || 0);

    const itemCGST = price * (gstPercent / 100 / 2);
    const itemSGST = price * (gstPercent / 100 / 2);

    subtotal += price;
    cgst += itemCGST;
    sgst += itemSGST;
  });*/
  orderedItems.forEach(item => {
  const price = Number(item.totalPrice || 0);

  const menuItem = menuMap.get(item.itemCode);

  const gstPlanName = menuItem?.gstPlan;
  const gstPlan = gstPlansMap[gstPlanName];

  const gstPercent = Number(gstPlan?.percentage || 0);
  const isInclusive = gstPlan?.inclusive || false;

  const gstRate = gstPercent / 100;

  let base = 0, itemCGST = 0, itemSGST = 0;

  if (isInclusive) {
    const basePrice = price / (1 + gstRate);
    const gstAmount = price - basePrice;

    base = basePrice;
    itemCGST = gstAmount / 2;
    itemSGST = gstAmount / 2;
  } else {
    base = price;
    itemCGST = base * (gstRate / 2);
    itemSGST = base * (gstRate / 2);
  }

  subtotal += base;   // IMPORTANT FIX
  cgst += itemCGST;
  sgst += itemSGST;
});

  setTotals({
    subtotal,
    cgst,
    sgst,
    grandTotal: subtotal + cgst + sgst
  });

}, [orderedItems, menuMap]);

const handlePrintBill = () => {
  if (!orderedItems.length) {
    alert("No items to print");
    return;
  }

  /*const rows = orderedItems.map(item => {
    const price = Number(item.totalPrice || 0);
    /*const cgst = price * 0.025;
    const sgst = price * 0.025;*/
    /*const menuItem = menuMap.get(item.itemCode);
const gstPercent = menuItem?.gstPercentage || 0;
const gstRate = gstPercent / 100;

const cgst = price * (gstRate / 2);
const sgst = price * (gstRate / 2);

    return `
      <tr>
        <td>${item.name}</td>
        <td>${item.quantity}</td>
        <td>₹${price.toFixed(2)}</td>
        <td>₹${cgst.toFixed(2)}</td>
        <td>₹${sgst.toFixed(2)}</td>
        <td>₹${(price + cgst + sgst).toFixed(2)}</td>
      </tr>
    `;
  }).join("");*/
  const rows = orderedItems.map(item => {
  const price = Number(item.totalPrice || 0);

  const menuItem = menuMap.get(item.itemCode);
  const gstPlanName = menuItem?.gstPlan;
  const gstPlan = gstPlansMap[gstPlanName];

  const gstPercent = Number(gstPlan?.percentage || 0);
  const isInclusive = gstPlan?.inclusive || false;

  const gstRate = gstPercent / 100;

  let base = 0, cgst = 0, sgst = 0;

  if (isInclusive) {
    const basePrice = price / (1 + gstRate);
    const gstAmount = price - basePrice;

    base = basePrice;
    cgst = gstAmount / 2;
    sgst = gstAmount / 2;
  } else {
    base = price;
    cgst = base * (gstRate / 2);
    sgst = base * (gstRate / 2);
  }

  return `
    <tr>
      <td>${item.name}</td>
      <td>${item.quantity}</td>
      <td>₹${base.toFixed(2)}</td>
      <td>₹${cgst.toFixed(2)}</td>
      <td>₹${sgst.toFixed(2)}</td>
      <td>₹${(base + cgst + sgst).toFixed(2)}</td>
    </tr>
  `;
}).join("");

  const printWindow = window.open('', '_blank');

  printWindow.document.write(`
    <html>
    <head>
      <title>Bill</title>
      <style>
        body { font-family: Arial; padding:20px; text-align:center; }
        table { width:100%; border-collapse:collapse; margin-top:20px; }
        th,td { border-bottom:1px solid #ddd; padding:8px; text-align:center; }
        th { font-weight:bold; }
        .total { text-align:right; margin-top:10px; }
      </style>
    </head>
    <body>
      <h2>${companyInfo.name || "Restaurant"}</h2>
      <div>Address: ${companyInfo.address || ""}, Phone: ${companyInfo.phone || ""}</div>
      ${gstin ? `<div>GSTIN: ${gstin}</div>` : ""}
      <div><b>Order No:</b> ${orderNo || ""}</div>
      <div><b>Table:</b> ${tableId || ""}</div>
      <div><b>Date:</b> ${new Date().toLocaleString()}</div>

      <table>
        <thead>
          <tr>
            <th>Item</th>
            <th>Qty</th>
            <th>Price</th>
            <th>CGST</th>
            <th>SGST</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>

      <div class="total">
        <div>Subtotal: ₹${totals.subtotal.toFixed(2)}</div>
        <div>CGST: ₹${totals.cgst.toFixed(2)}</div>
        <div>SGST: ₹${totals.sgst.toFixed(2)}</div>
        <h3>Grand Total: ₹${totals.grandTotal.toFixed(2)}</h3>
      </div>

      <p>Thank you for dining with us!</p>

      <script>
        window.onload = () => {
          window.print();
        };
      </script>
    </body>
    </html>
  `);

  printWindow.document.close();
};

const [isScriptLoaded, setIsScriptLoaded] = useState(false);

/*useEffect(() => {
  const script = document.createElement("script");
  script.src = "https://checkout.razorpay.com/v1/checkout.js";
  script.async = true;
  script.onload = () => {
    setIsScriptLoaded(true);
  };
  document.body.appendChild(script);
}, []);*/
useEffect(() => {
  if (window.Razorpay) {
    setIsScriptLoaded(true);
    return;
  }

  const script = document.createElement("script");
  script.src = "https://checkout.razorpay.com/v1/checkout.js";
  script.async = true;

  script.onload = () => {
    console.log("✅ Razorpay loaded");
    setIsScriptLoaded(true);
  };

  script.onerror = () => {
    console.error("❌ Razorpay failed to load");
  };

  document.body.appendChild(script);
}, []);

/*const payNow = async () => {
  // Online payment logic goes here (Razorpay)
  console.log('Online payment triggered');
  // For now, just simulate payment success:
  alert('Online payment simulated');
};*/

const payNow = async () => {
  /*if (!isScriptLoaded) {
    alert("Payment gateway not loaded");
    return;
  }*/

     if (!window.Razorpay) {
    alert("Still loading payment... Please try again.");
    return;
  }
 if (!isScriptLoaded) {
  alert("Please wait, loading payment gateway...");
  return;
}

  const finalAmount = Number(totals.grandTotal || 0);

  if (finalAmount <= 0) {
    alert("Invalid amount");
    return;
  }

  const options = {
    key: "rzp_test_9Mbg2bbubhgN1z",
    amount: Math.round(finalAmount * 100), 
    currency: "INR",

    name: companyInfo.name || "Restaurant",

    description: `Order No: ${orderNo || orderId}`,

    handler: async function (response) {
  try {
    console.log("Payment success:", response);

    //  ONLY store payment
    const paymentDocId = `payment_${orderId}_${Date.now()}`;

    await setDoc(doc(db, "payments", paymentDocId), {
      paymentDocId,
      orderId,
      tableId: tableId || null,
      cartId: cartId || null,
      companyCode,
      unitCode,
      amount: Number(totals.grandTotal),
      paymentMethod: "online",
      paymentId: response.razorpay_payment_id,
      status: "success",
      date: new Date(),
    });

    console.log("✅ Payment stored successfully:", paymentDocId);

    // Optional: call backend API to verify payment
    // await fetch("/verify-payment", { method: "POST", body: JSON.stringify(response) });

    alert("Payment Successful! Thank you for your order.");

    // Optional navigation
    // navigate("/success");

  } catch (err) {
    //console.error(" Error after payment:", err);
    console.error("❌ Firestore write failed:", err);
  }
},

   prefill: {
      name: "Customer",
      email: "customer@example.com",
      contact: "",
    },

    theme: {
      color: "#735DA5",
    },

    methods: {
      upi: true,
      card: true,
      netbanking: true,
      wallet: false,
    },
  };

  const rzp = new window.Razorpay(options);
  rzp.open();
};

  if (loading) return <Typography>Loading your bill...</Typography>;

  return (
    <Box sx={{ maxWidth: 800, mx: 'auto', p: 3, border: '1px solid #ccc', borderRadius: 2 }}>
      <Typography variant="h4" align="center" sx={{ mb: 2 }}>Your Bill</Typography>
      <Divider sx={{ mb: 2 }} />

      <Typography variant="h6" align="center">{companyInfo.name}</Typography>
      <Typography align="center">Address: {companyInfo.address}, Phone: {companyInfo.phone}</Typography>
      {gstin && (<Typography align="center">GSTIN: {gstin}</Typography>)}
      <Typography align="center">Date: {new Date().toLocaleString()}</Typography>
      <Typography align="center" sx={{ mb: 2 }}>Order No: {orderNo}</Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell align="center">Qty</TableCell>
              <TableCell align="right">Price</TableCell>
              <TableCell align="right">CGST</TableCell>
              <TableCell align="right">SGST</TableCell>
              <TableCell align="right">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/*{orderedItems.map(item => {
              const price = Number(item.totalPrice || 0);
              const menuItem = menuMap.get(item.itemCode);
const gstPercent = menuItem?.gstPercentage || 0;
const gstRate = gstPercent / 100;

const cgst = price * (gstRate / 2);
const sgst = price * (gstRate / 2);
              const total = price + cgst + sgst;
              return (
                <TableRow key={item.id}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell align="center">{item.quantity}</TableCell>
                  <TableCell align="right">{price.toFixed(2)}</TableCell>
                  <TableCell align="right">{cgst.toFixed(2)}</TableCell>
                  <TableCell align="right">{sgst.toFixed(2)}</TableCell>
                  <TableCell align="right">{total.toFixed(2)}</TableCell>
                </TableRow>
              );
            })}*/}
            {orderedItems.map(item => {
  const price = Number(item.totalPrice || 0);

  const menuItem = menuMap.get(item.itemCode);
  const gstPlanName = menuItem?.gstPlan;
  const gstPlan = gstPlansMap[gstPlanName];

  const gstPercent = Number(gstPlan?.percentage || 0);
  const isInclusive = gstPlan?.inclusive || false;

  const gstRate = gstPercent / 100;

  let base = 0, cgst = 0, sgst = 0;

  if (isInclusive) {
    const basePrice = price / (1 + gstRate);
    const gstAmount = price - basePrice;

    base = basePrice;
    cgst = gstAmount / 2;
    sgst = gstAmount / 2;
  } else {
    base = price;
    cgst = base * (gstRate / 2);
    sgst = base * (gstRate / 2);
  }

  const total = base + cgst + sgst;

  return (
    <TableRow key={item.id}>
      <TableCell>{item.name}</TableCell>
      <TableCell align="center">{item.quantity}</TableCell>
      <TableCell align="right">{base.toFixed(2)}</TableCell>   
      <TableCell align="right">{cgst.toFixed(2)}</TableCell>
      <TableCell align="right">{sgst.toFixed(2)}</TableCell>
      <TableCell align="right">{total.toFixed(2)}</TableCell>
    </TableRow>
  );
})}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ mt: 2, textAlign: 'right' }}>
        <Typography>Subtotal: ₹{totals.subtotal.toFixed(2)}</Typography>
        <Typography>CGST: ₹{totals.cgst.toFixed(2)}</Typography>
        <Typography>SGST: ₹{totals.sgst.toFixed(2)}</Typography>
        <Typography variant="h6">Grand Total: ₹{totals.grandTotal.toFixed(2)}</Typography>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
        <Button variant="outlined" onClick={handlePrintBill} fullWidth>Download Bill</Button>
        {/*<Button variant="contained" color="primary" onClick={handlePayment} fullWidth>Pay Now</Button>*/}
<Button
  variant="contained"
  color="primary"
  fullWidth
  onClick={payNow}
   disabled={!isScriptLoaded} 
>
  {isScriptLoaded ? "Pay Now" : "Loading Payment..."}
</Button>
       
      </Box>
    </Box>
  );
}